//
// Module for the Withholdings Detail partial view
//
rs.module("participant/benefit/withholdings/detail",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        // Initialize the module
        function initialize(messages) {

            if (messages && messages.length > 0) {
                eventBanner.addInformationalMessages(messages);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);